module.exports = __webpack_public_path__ + "img/14exp.4ef5264c.jpg";